export const PORTUGUESE = {
  question: 'Qual é o seu peso ?',
  btn_leger_text: 'Ligeiro',
  leger_info_content: `Perturbações fisiológicas ligeiras: sono leve, para bem-estar, relaxamento muscular
  Transtornos psicológicos ligeiros: necessidade de relaxamento, necessidade de concentração.`,
  btn_moyen_text: 'Médio',
  moyen_info_content: `Problemas fisiológicos médios: Sono de qualidade, dores, dores musculares ligeiras, inflamações, problemas digestivos.
  Problemas psicológicos médios: Ansiedade, stress, dificuldade de concentração.`,
  btn_intensity_text: 'Potente',
  intensity_info_content: `Distúrbios fisiológicos: problemas de sono, dores e dores intensas, dores musculares e articulares, epilepsia e doenças degenerativas, dores menstruais, anorexia.
  Distúrbios psicológicos: ansiedade, stresse, problemas de concentração`,
  important_text:
    'este teste é uma dica para calcular a dosagem recomendada de CBD. Não constitui de forma alguma um conselho médico ou uma receita.',
  powered_text: 'Perguntas ? Estamos aqui para ajudar',
  btn_calcul_text: 'Calcular',
  btn_reset_text: 'Redefinir',
  get_calculator_text: 'Use esta calculadora',
  btn_copy_text: 'cópia de',
  weight: 'Peso',
  trouble: 'Problema',
  recommendation_text:
    'Recomendação em número de gotas de acordo com a concentração em% do óleo adquirido.',
  gout_of_day: 'Gotas por dia',
  delaide_text: 'Duração da garrafa em dias',
  oil: 'Óleo',
  btn_recalculate_text: 'Calcular ainda',
  important: 'Importante',
  effet_question: 'Que efeito procura ?',
  text_alert: `O óleo de CDB não se destina a uso médico e não deve ser utilizado para fins de rastreio, diagnóstico, tratamento, cura, mitigação, prevenção, gestão e monitorização de doenças.
  Os suplementos alimentares e o óleo de CDB não são um substituto para uma dieta variada e equilibrada nem um estilo de vida saudável.`,
  back_to_shop: 'Voltar às compras',
  leger: 'Ligeiro',
  moyen: 'Médio',
  intense: 'Potente',
};
